import React, {Component} from 'react';
import '../comCss/Poke.css';
import CodeBlock from '../CodeBlock';
import {Palette} from 'react-palette';

export class PokeCard extends Component {

  constructor(props) {
    super(props);
    //Set default message
    this.state = {
    pokemon: 700,
    hovered: false
    }
  }
  onMouseEnter(){
    this.setState({ hovered: true });
  };

  onMouseLeave(){
    this.setState({ hovered: false });
  };

  change(){
    const min = 1;
    const max = 800;
    const rand = min + Math.random() * (max - min);
    this.setState({ pokemon: Math.floor(rand) });
  };

    render(){ 
      const { hovered } = this.state;
   return (
    <div>
    <Palette src={`https://pokeres.bastionbot.org/images/pokemon/${this.state.pokemon}.png`}>
    {({ data} ) => (
          <div class="pokemon-container" style={hovered ? { backgroundColor: data.lightVibrant, boxShadow: '0px 5px 20px ' + data.lightVibrant }: {}} onMouseOver={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}>
          <h3 class="pro-tit"><b> Pokemon </b>#{this.state.pokemon}</h3>
          <img src={`https://pokeres.bastionbot.org/images/pokemon/${this.state.pokemon}.png`} class="poke-img" />
           </div>
          )}
      </Palette>
      <button className="rand-btn" onClick={this.change.bind(this)}>Random</button>
      </div>
   );
 }
 }

 export class PokeCom extends Component {

   render(){ 
    const a = <PokeCard />
    const js = `export class PokeCard extends Component {

      constructor(props) {
        super(props);
        //Set default message
        this.state = {
        pokemon: 150,
        hovered: false
        }
      }
      onMouseEnter(){
        this.setState({ hovered: true });
      };
    
      onMouseLeave(){
        this.setState({ hovered: false });
      };
    
        render(){ 
          const { hovered } = this.state;
       return (
        <div>
        <Palette src={"https://pokeres.bastionbot.org/images/pokemon/{this.state.pokemon}.png"}>
        {({ data} ) => (
              <div class="pokemon-container" style={hovered ? {
                 backgroundColor: data.lightVibrant, boxShadow: '0px 5px 20px ' + data.lightVibrant 
                }: 
              {}} onMouseOver={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}>
              <h3 class="pro-tit"><b> Pokemon </b>#{this.state.pokemon}</h3>
              <img src={"https://pokeres.bastionbot.org/images/pokemon/{this.state.pokemon}.png"} class="poke-img" />
               </div>
              )}
          </Palette>
          </div>
       );
     }
     }`

  return (
    <div class="project-view-section-2">
            <div>
                <h3 class="hs2-recent-tit">Pokedex UI</h3>
                <img src={process.env.PUBLIC_URL + "/images/Projects/Poke/dex.png"} class="pws1-nike-imgs" />
            </div>

            <div>
                <p class="pws1-pro-descript">Here is a little demo i made, you can hover over and see the background <br/> change acording to the lightest dominant color of the Pokemon. <br/> You can find the webapp through this <a href="https://pokedex-f895a.firebaseapp.com" style={{color: "#E8EC30"}}>link.</a></p>
                < CodeBlock 
                code = "javascript"
                lang = "React"
                title = "Pokemon Card"
                playground = {a}
                js = {js}
                css = "last"
                bgColor = "#FEFEFE"
                />
            </div>

            <div>
                <h3 class="hs2-recent-tit">Pokemon UI</h3>
                <img src={process.env.PUBLIC_URL + "/images/Projects/Poke/mew.jpg"} class="pws1-poke-imgs"/>
            </div>
    </div>
  );
}
}


export default PokeCom;
